import axios from 'axios';

import { CONTACTS } from 'RestAPIs/endpoints';

export enum ContactType {
  APPLICATION_MANAGER = 'APPLICATION_MANAGER',
  APPLICATION_OWNER = 'APPLICATION_OWNER',
  ROSTER_PROCESS_MANAGER = 'ROSTER_PROCESS_MANAGER',
  FLEX_PROCESS_MANAGER = 'FLEX_PROCESS_MANAGER',
  ICT_MANAGER = 'ICT_MANAGER',
  DATABASE_VIEWS_API_INTEGRATIONS = 'DATABASE_VIEWS_API_INTEGRATIONS',
  EXPORT_SALARY_ADMINISTRATOR = 'EXPORT_SALARY_ADMINISTRATOR',
  EXPORT_FINANCIAL = 'EXPORT_FINANCIAL',
  SECURITY_OFFICER = 'SECURITY_OFFICER'
}

export type Contact = {
  id: number;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  remark?: string;
  type: ContactType;
};

export const getContacts = () => axios.get<Contact[]>(CONTACTS);
export const saveContact = (contact: Omit<Contact, 'id'>) =>
  axios.post<Contact>(CONTACTS, contact);
export const updateContact = (id: number, contact: Omit<Contact, 'id'>) =>
  axios.put<Contact>(`${CONTACTS}/${id}`, contact);
export const deleteContact = (id: number) => axios.delete(`${CONTACTS}/${id}`);
